import { ElementRef } from '@angular/core';
import { FormGroupDirective, NgControl, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Subject } from 'rxjs';
import {
  CanUpdateErrorState,
  mixinErrorState,
  CanDisable,
  HasTabIndex,
  mixinDisabled,
  mixinTabIndex,
  _AbstractConstructor,
  _Constructor,
} from '@nimbus-library/utils/material-mixins-types';

export class MatDndItemListBase {
  public readonly stateChanges: Subject<void> = new Subject<void>();

  public constructor(
    public _elementRef: ElementRef,
    public _defaultErrorStateMatcher: ErrorStateMatcher,
    public _parentForm: NgForm,
    public _parentFormGroup: FormGroupDirective,
    public ngControl: NgControl,
  ) {}
}

export const MATERIAL_DND_ITEM_LIST_MIXIN_BASE: _Constructor<HasTabIndex> &
  _AbstractConstructor<HasTabIndex> &
  _Constructor<CanDisable> &
  _AbstractConstructor<CanDisable> &
  _Constructor<CanUpdateErrorState> &
  _AbstractConstructor<CanUpdateErrorState> &
  typeof MatDndItemListBase = mixinTabIndex(mixinDisabled(mixinErrorState(MatDndItemListBase)));
